module.exports = __webpack_public_path__ + "static/media/Beacon-Meadows-declaration.dbd0336a.pdf";